module.exports = __webpack_public_path__ + "img/12_94.349f02e6.png";